// extracted by mini-css-extract-plugin
export var header = "_us-1";
export var maskBottom = "_us-6";
export var maskMiddle = "_us-7";
export var maskTop = "_us-5";
export var root = "_us-0";
export var scrollDownButton = "_us-3";
export var scrollDownButtonHidden = "_us-4";
export var viewport = "_us-2";